export default __webpack_public_path__ + "static/media/icon-covered.a2825c44.svg";